export const investmentsPtBr = {
  title: 'Investimentos',
  description: 'Posições de investimento sincronizadas via Open Finance.',
  empty:
    'Nenhum investimento encontrado. Conecte contas na integração Open Finance para sincronizar.',
  connectAccounts: 'Conectar contas em Integrações',
  addAccount: 'Adicionar conta',
  editAccount: 'Editar conta',
  investmentAccountsSection: 'Contas de investimento',
  accountCard: {
    branch: 'Ag.',
    account: 'Conta',
    balance: 'Saldo',
    portfolio: 'Carteira',
    positions: '{{count}} posição(ões)',
    activePositions: '{{count}} ativa(s)',
    openFinance: 'Open Finance',
    manual: 'Manual',
    manageAccess: 'Gerenciar acesso',
    updatedAt: 'Atualizado em {{date}}',
  },
  createAccount: {
    title: 'Criar conta de investimento',
    description:
      'Cadastre uma conta de investimento manualmente (ex.: XP, BTG, Clear) para conciliar extratos.',
    validationRequired: 'Preencha todos os campos obrigatórios',
    success: 'Conta de investimento criada com sucesso',
    error: 'Erro ao criar conta',
    accountName: 'Nome da conta',
    platformName: 'Nome da plataforma',
    bankCode: 'Código do banco',
    bankCodeHint: 'Opcional. Ex.: 102 (XP Investimentos), 208 (BTG)',
    cancel: 'Cancelar',
    submit: 'Criar conta',
    selectEntity: 'Selecione a entidade',
  },
  totalPortfolio: 'Total da carteira',
  referenceDate: 'Data de referência',
  assetsCount: '{{count}} ativo(s)',
  card: {
    quantity: 'Qtd',
    ofSubtype: ' do subtipo',
    liquidity: 'Liquidez:',
  },
  termBucket: {
    label: 'Prazo',
    short: 'Curto prazo',
    long: 'Longo prazo',
    shortHint: 'Circulante',
    longHint: 'Não circulante',
    unclassified: 'Não classificado',
    unclassifiedHint: 'Escolha curto ou longo prazo para confirmar e vincular a conta contábil.',
    overridden: 'Definido manualmente',
    override: 'Classificar prazo',
    saved: 'Classificação de prazo atualizada',
    error: 'Erro ao atualizar a classificação de prazo',
    linkWarningTitle: 'Conta contábil não vinculada',
    linkWarning:
      'A classificação foi salva, mas a conta contábil desta posição não pôde ser vinculada. Verifique a configuração das contas raiz de investimento em Configurações.',
    unlinkedLongBadge: 'Sem conta GL',
    unlinkedLongHint:
      'Posição de longo prazo sem conta contábil vinculada — confirme o prazo no detalhe antes do fecho.',
    unclassifiedBadge: 'Não classificado',
    unclassifiedBadgeHint:
      'Posição sem classificação de prazo (CP/LP) — confirme o prazo no detalhe para vincular a conta contábil.',
  },
  allocation: 'Alocação',
  searchAsset: 'Buscar ativo...',
  balance: 'Saldo',
  return: 'Rendimento',
  portfolioPct: '% da carteira',
  ofPortfolio: 'da carteira',
  asset: 'Ativo',
  syncFooter: 'Dados sincronizados via Pluggy Open Finance',
  historySection: 'Histórico',
  historyHint: 'Posições encerradas ou com resgate total',
  showZeroed: 'Mostrar histórico',
  hideZeroed: 'Ocultar histórico',
  hideValues: 'Ocultar valores',
  showValues: 'Mostrar valores',
  filters: {
    entity: 'Entidade',
    connection: 'Conexão',
    bankAccount: 'Conta bancária',
    type: 'Tipo',
    subtype: 'Subtipo',
    all: 'Todos',
    clearFilters: 'Limpar filtros',
    noResultsHint: 'Limpe os filtros para ver todos os investimentos.',
  },
  types: {
    EQUITY: 'Renda variável',
    MUTUAL_FUND: 'Fundos',
    FIXED_INCOME: 'Renda fixa',
    ETF: 'ETF',
    SECURITY: 'Previdência',
    COE: 'COE',
    OTHER: 'Outros',
  },
  subtypes: {
    STOCK: 'Ações',
    BDR: 'BDR',
    REAL_ESTATE_FUND: 'FII',
    DERIVATIVES: 'Derivativos',
    OPTION: 'Opções',
    INVESTMENT_FUND: 'Fundo de investimento',
    STOCK_FUND: 'Fundo de ações',
    MULTIMARKET_FUND: 'Fundo multimercado',
    EXCHANGE_FUND: 'Fundo cambial',
    FIXED_INCOME_FUND: 'Fundo de renda fixa',
    FIP_FUND: 'FIP',
    OFFSHORE_FUND: 'Fundo offshore',
    ETF_FUND: 'Fundo ETF',
    CDB: 'CDB',
    TREASURY: 'Tesouro',
    LCI: 'LCI',
    LCA: 'LCA',
    CRI: 'CRI',
    CRA: 'CRA',
    DEBENTURES: 'Debêntures',
    RETIREMENT: 'Previdência',
    PGBL: 'PGBL',
    VGBL: 'VGBL',
    STRUCTURED_NOTE: 'Nota estruturada',
    OTHER: 'Outros',
  },
  detail: {
    backToInvestments: 'Voltar aos investimentos',
    overview: 'Visão geral',
    transactions: 'Transações',
    noTransactions: 'Nenhuma transação sincronizada.',
    transactionType: {
      BUY: 'Aplicação',
      SELL: 'Resgate',
      TAX: 'Imposto',
      TRANSFER: 'Transferência',
      CASH: 'Movimentação de caixa',
      FEE: 'Tarifa',
      CANCEL: 'Cancelamento',
    },
    transactionTable: {
      type: 'Tipo',
      date: 'Data',
      unitValue: 'Valor unitário',
      totalValue: 'Valor total',
      quantity: 'Quantidade',
    },
    balance: 'Saldo',
    amount: 'Valor aplicado',
    value: 'Valor de mercado',
    quantity: 'Quantidade',
    rate: 'Taxa',
    rateType: 'Tipo de taxa',
    fixedAnnualRate: 'Taxa anual fixa',
    annualRate: 'Rentabilidade 12m',
    amountProfit: 'Lucro/prejuízo',
    amountWithdrawal: 'Valor disponível',
    amountOriginal: 'Valor original',
    date: 'Data de referência',
    dueDate: 'Vencimento',
    gracePeriodDate: 'Carência',
    termBucket: 'Classificação de prazo',
    issueDate: 'Emissão',
    issuer: 'Emissor',
    status: 'Status',
    entity: 'Entidade',
    linkedAccount: 'Conta de investimento vinculada',
    custody: 'Custódia',
    fetchTransactions: 'Buscar transações via API',
    manualLiquidityDays: 'Liquidez para resgate (D+X)',
    manualLiquidityDaysHint:
      'Define se este investimento entra no "Caixa ampliado" do Fluxo de Caixa. Deixe em branco para usar a regra automática por tipo.',
    manualLiquidityDaysAuto: 'Automático (por tipo)',
    manualLiquidityDaysSuffix: 'dias',
  },
  glPending: {
    title: 'Investimentos com GL pendente',
    subtitle:
      'Posições (incluindo zeradas/históricas) que bloqueiam a postagem em Numerários em Trânsito por falta de conta CP/LP.',
    refresh: 'Atualizar',
    count: '{{count}} pendência(s)',
    loadError: 'Não foi possível carregar as pendências de GL.',
    emptyTitle: 'Nenhuma pendência de GL',
    emptyHint: 'Todas as posições com links de conciliação têm conta contábil CP/LP válida.',
    backToList: 'Voltar aos investimentos',
    historical: 'Histórico',
    derived: 'Derivado: {{bucket}}',
    toggleLinks: 'Mostrar links afetados',
    affectedLinks: 'Links / postings afetados',
    noAudit: 'Sem auditoria',
    periodClosedBadge: 'Período fechado',
    periodClosedTitle: 'Período contábil fechado',
    periodClosedHint:
      'O período contábil deste lançamento não está aberto. Reabra o período ou tome a decisão operacional adequada antes de reprocessar.',
    periodClosedPartial: '{{count}} link(s) com período fechado foram ignorados.',
    retry: 'Reprocessar',
    retryAll: 'Reprocessar links',
    retrySuccess: 'Postagem GL reprocessada com sucesso',
    retryFailed: 'Falha ao reprocessar a postagem GL',
    linkMeta: 'Data {{date}} · Período {{period}} ({{status}})',
    prev: 'Anterior',
    next: 'Próxima',
    openQueue: 'Pendências GL',
    openQueueHint: 'Corrigir posições sem conta CP/LP que bloqueiam Numerários em Trânsito',
    columns: {
      entity: 'Entidade',
      platform: 'Banco / plataforma',
      investment: 'Investimento',
      balance: 'Saldo',
      quantity: 'Qtd',
      termBucket: 'CP / LP',
      glAccount: 'Conta GL',
      reason: 'Motivo',
      links: 'Links',
      actions: 'Ações',
    },
    reasons: {
      MISSING_TERM_BUCKET_CONFIRMATION: 'Confirmação de curto/longo prazo pendente',
      MISSING_APPLIED_COA: 'Plano de contas aplicado ausente',
      ROOT_SETTINGS_MISSING: 'Conta-raiz CP/LP não configurada',
      MISSING_GL_OFFSET: 'Conta GL da posição ausente',
      GL_OFFSET_INACTIVE: 'Conta GL inativa',
      GL_OFFSET_NOT_POSTABLE: 'Conta GL não postável',
      GL_OFFSET_WRONG_COA_VERSION: 'Conta GL fora da versão aplicada',
      GL_OFFSET_OUTSIDE_ROOT: 'Conta GL fora da raiz CP/LP',
      GL_OFFSET_INCOMPATIBLE_TYPE: 'Conta GL incompatível (ASSET/DEBIT)',
    },
  },
};

export const investmentsEn = {
  title: 'Investments',
  description: 'Investment positions synced via Open Finance.',
  empty: 'No investments found. Connect accounts in the Open Finance integration to sync.',
  connectAccounts: 'Connect accounts in Integrations',
  addAccount: 'Add account',
  editAccount: 'Edit account',
  investmentAccountsSection: 'Investment accounts',
  accountCard: {
    branch: 'Branch',
    account: 'Account',
    balance: 'Balance',
    portfolio: 'Portfolio',
    positions: '{{count}} position(s)',
    activePositions: '{{count}} active',
    openFinance: 'Open Finance',
    manual: 'Manual',
    manageAccess: 'Manage access',
    updatedAt: 'Updated on {{date}}',
  },
  createAccount: {
    title: 'Create investment account',
    description:
      'Register an investment account manually (e.g. XP, BTG, Clear) to reconcile statements.',
    validationRequired: 'Fill in all required fields',
    success: 'Investment account created successfully',
    error: 'Error creating account',
    accountName: 'Account name',
    platformName: 'Platform name',
    bankCode: 'Bank code',
    bankCodeHint: 'Optional. E.g. 102 (XP Investimentos), 208 (BTG)',
    cancel: 'Cancel',
    submit: 'Create account',
    selectEntity: 'Select entity',
  },
  totalPortfolio: 'Total portfolio',
  referenceDate: 'Reference date',
  assetsCount: '{{count}} asset(s)',
  card: {
    quantity: 'Qty',
    ofSubtype: ' of subtype',
    liquidity: 'Liquidity:',
  },
  termBucket: {
    label: 'Term',
    short: 'Short-term',
    long: 'Long-term',
    shortHint: 'Current',
    longHint: 'Non-current',
    unclassified: 'Not yet classified',
    unclassifiedHint: 'Choose short or long-term to confirm and link the GL account.',
    overridden: 'Set manually',
    override: 'Set term',
    saved: 'Term classification updated',
    error: 'Failed to update term classification',
    linkWarningTitle: 'GL account not linked',
    linkWarning:
      'The classification was saved, but this position\u2019s GL account could not be linked. Check the investment root account configuration in Settings.',
    unlinkedLongBadge: 'No GL account',
    unlinkedLongHint:
      'Long-term position without a linked GL account — confirm the term on the detail page before close.',
    unclassifiedBadge: 'Unclassified',
    unclassifiedBadgeHint:
      'Position without a short/long-term classification — confirm the term on the detail page to link the GL account.',
  },
  allocation: 'Allocation',
  searchAsset: 'Search asset...',
  balance: 'Balance',
  return: 'Return',
  portfolioPct: '% of portfolio',
  ofPortfolio: 'of portfolio',
  asset: 'Asset',
  syncFooter: 'Data synced via Pluggy Open Finance',
  historySection: 'History',
  historyHint: 'Closed positions or fully withdrawn',
  showZeroed: 'Show history',
  hideZeroed: 'Hide history',
  hideValues: 'Hide values',
  showValues: 'Show values',
  filters: {
    entity: 'Entity',
    connection: 'Connection',
    bankAccount: 'Bank account',
    type: 'Type',
    subtype: 'Subtype',
    all: 'All',
    clearFilters: 'Clear filters',
    noResultsHint: 'Clear filters to see all investments.',
  },
  types: {
    EQUITY: 'Equity',
    MUTUAL_FUND: 'Mutual funds',
    FIXED_INCOME: 'Fixed income',
    ETF: 'ETF',
    SECURITY: 'Pension',
    COE: 'COE',
    OTHER: 'Other',
  },
  subtypes: {
    STOCK: 'Stocks',
    BDR: 'BDR',
    REAL_ESTATE_FUND: 'REIT',
    DERIVATIVES: 'Derivatives',
    OPTION: 'Options',
    INVESTMENT_FUND: 'Investment fund',
    STOCK_FUND: 'Stock fund',
    MULTIMARKET_FUND: 'Multimarket fund',
    EXCHANGE_FUND: 'Exchange fund',
    FIXED_INCOME_FUND: 'Fixed income fund',
    FIP_FUND: 'FIP',
    OFFSHORE_FUND: 'Offshore fund',
    ETF_FUND: 'ETF fund',
    CDB: 'CDB',
    TREASURY: 'Treasury',
    LCI: 'LCI',
    LCA: 'LCA',
    CRI: 'CRI',
    CRA: 'CRA',
    DEBENTURES: 'Debentures',
    RETIREMENT: 'Retirement',
    PGBL: 'PGBL',
    VGBL: 'VGBL',
    STRUCTURED_NOTE: 'Structured note',
    OTHER: 'Other',
  },
  detail: {
    backToInvestments: 'Back to investments',
    overview: 'Overview',
    transactions: 'Transactions',
    noTransactions: 'No transactions synced.',
    transactionType: {
      BUY: 'Application',
      SELL: 'Withdrawal',
      TAX: 'Tax',
      TRANSFER: 'Transfer',
      CASH: 'Cash movement',
      FEE: 'Fee',
      CANCEL: 'Cancellation',
    },
    transactionTable: {
      type: 'Type',
      date: 'Date',
      unitValue: 'Unit value',
      totalValue: 'Total value',
      quantity: 'Quantity',
    },
    balance: 'Balance',
    amount: 'Amount invested',
    value: 'Market value',
    quantity: 'Quantity',
    rate: 'Rate',
    rateType: 'Rate type',
    fixedAnnualRate: 'Fixed annual rate',
    annualRate: '12m return',
    amountProfit: 'Profit/loss',
    amountWithdrawal: 'Available value',
    amountOriginal: 'Original value',
    date: 'Reference date',
    dueDate: 'Maturity',
    gracePeriodDate: 'Grace period',
    termBucket: 'Term classification',
    issueDate: 'Issue date',
    issuer: 'Issuer',
    status: 'Status',
    entity: 'Entity',
    linkedAccount: 'Linked investment account',
    custody: 'Custody',
    fetchTransactions: 'Fetch transactions via API',
    manualLiquidityDays: 'Redemption liquidity (D+X)',
    manualLiquidityDaysHint:
      'Controls whether this investment counts toward Cash Flow\'s "expanded cash". Leave blank to use the automatic type-based rule.',
    manualLiquidityDaysAuto: 'Automatic (by type)',
    manualLiquidityDaysSuffix: 'days',
  },
  glPending: {
    title: 'Investments with pending GL',
    subtitle:
      'Positions (including zeroed/historical) that block Cash in Transit posting due to missing CP/LP accounts.',
    refresh: 'Refresh',
    count: '{{count}} pending item(s)',
    loadError: 'Could not load GL pending items.',
    emptyTitle: 'No GL pending items',
    emptyHint:
      'All positions with reconciliation links have a valid short-term/long-term GL account.',
    backToList: 'Back to investments',
    historical: 'Historical',
    derived: 'Derived: {{bucket}}',
    toggleLinks: 'Show affected links',
    affectedLinks: 'Affected links / postings',
    noAudit: 'No audit',
    periodClosedBadge: 'Period closed',
    periodClosedTitle: 'Accounting period closed',
    periodClosedHint:
      'The accounting period for this posting is not open. Reopen the period or take the appropriate operational decision before retrying.',
    periodClosedPartial: '{{count}} link(s) with a closed period were skipped.',
    retry: 'Retry',
    retryAll: 'Retry links',
    retrySuccess: 'GL posting retried successfully',
    retryFailed: 'Failed to retry GL posting',
    linkMeta: 'Date {{date}} · Period {{period}} ({{status}})',
    prev: 'Previous',
    next: 'Next',
    openQueue: 'GL pending',
    openQueueHint: 'Fix positions without CP/LP accounts that block Cash in Transit',
    columns: {
      entity: 'Entity',
      platform: 'Bank / platform',
      investment: 'Investment',
      balance: 'Balance',
      quantity: 'Qty',
      termBucket: 'ST / LT',
      glAccount: 'GL account',
      reason: 'Reason',
      links: 'Links',
      actions: 'Actions',
    },
    reasons: {
      MISSING_TERM_BUCKET_CONFIRMATION: 'Short/long-term confirmation pending',
      MISSING_APPLIED_COA: 'Applied chart of accounts missing',
      ROOT_SETTINGS_MISSING: 'ST/LT root account not configured',
      MISSING_GL_OFFSET: 'Position GL account missing',
      GL_OFFSET_INACTIVE: 'GL account inactive',
      GL_OFFSET_NOT_POSTABLE: 'GL account not postable',
      GL_OFFSET_WRONG_COA_VERSION: 'GL account not on applied CoA version',
      GL_OFFSET_OUTSIDE_ROOT: 'GL account outside ST/LT root',
      GL_OFFSET_INCOMPATIBLE_TYPE: 'GL account incompatible (ASSET/DEBIT)',
    },
  },
};
